import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { DocsSidebar } from './DocsSidebar';
import { PanelLeftOpen } from 'lucide-react';

const DocsLayout: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed((collapsed) => !collapsed);
  };

  const handleSidebarToggle = () => {
    if (typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches) {
      setIsMobileMenuOpen(true);
      return;
    }

    toggleSidebar();
  };

  return (
    <div className={`docs-root docs-article-shell ${isSidebarCollapsed ? 'docs-sidebar-collapsed' : ''}`}>
      <button
        type="button"
        onClick={handleSidebarToggle}
        className="docs-sidebar-floating-toggle"
        aria-controls="docs-sidebar"
        aria-label={isSidebarCollapsed ? 'Show docs sidebar' : 'Open docs menu'}
        title={isSidebarCollapsed ? 'Show sidebar' : 'Open menu'}
      >
        <PanelLeftOpen className="h-5 w-5" aria-hidden="true" />
      </button>

      <div className="docs-layout-body">
        <DocsSidebar
          isMobileMenuOpen={isMobileMenuOpen}
          isSidebarCollapsed={isSidebarCollapsed}
          showHeader
          onToggleSidebar={toggleSidebar}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
        <main className="docs-main">
          <div className="docs-main-inner">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile overlay */}
      {isMobileMenuOpen && (
        <button
          type="button"
          className="docs-mobile-overlay"
          aria-label="Close article menu"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default DocsLayout;
